module.exports = __webpack_public_path__ + "img/user.70282faf.svg";